import i18n from "i18n";
const LABEL_KEYS = {
  search_messages: "tool_call_labels.search_messages"
};
const humanize = (tool) => {
  const words = tool.replace(/_/g, " ").trim();
  return `${words.charAt(0).toUpperCase()}${words.slice(1)}`;
};
export const toolCallLabel = (tool) => LABEL_KEYS[tool] ? i18n.t(LABEL_KEYS[tool], { ns: "enterprise_ai" }) : humanize(tool);
export const formatDuration = (durationMs) => durationMs < 1e3 ? `${durationMs} ms` : `${(durationMs / 1e3).toFixed(1)} s`;
